/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import { I18nMessage, Link, useTranslations } from "@i18n/next";
import { HallowAnalyticsEvent, useAnalytics } from "@packages/analytics";
import { URL_BASE } from "@packages/sdk";
import type { ThemeType } from "@packages/ui";
import { Button, IconButton, InfoIcon, Text, useConfirm } from "@packages/ui";

const primaryButtonStyles: Interpolation<ThemeType> = (theme: ThemeType) => ({
  color: theme.semanticColors.accentMedium,
});

const reportedForHeaderStyles: Interpolation = {
  alignItems: "center",
  display: "flex",
  justifyContent: "space-between",
};

export const ReportedGuidelinesDialog = () => {
  const t = useTranslations();
  const analytics = useAnalytics();

  const dialogReportGuidelines = useConfirm({
    description: () => t("pad_reported_description"),
    primaryButton: () => (
      <Button asChild css={primaryButtonStyles} variant="outline">
        <Link href={`${URL_BASE}/community-guidelines`} target="_blank">
          {t("dialog_report_guidelines_button")}
        </Link>
      </Button>
    ),
    showCloseButton: true,
    size: "m",
    title: () => t("pad_review_reported_posts"),
  });

  return (
    <div css={reportedForHeaderStyles}>
      <Text size="l" type="title" as="h2">
        <I18nMessage message="parish_admin_dashboard_moderation_reported_posts" />
      </Text>
      <IconButton
        onClick={async () => {
          analytics.track({
            event: HallowAnalyticsEvent.TappedCommunityReportInfo,
          });
          await dialogReportGuidelines.show();
        }}
        icon={<InfoIcon />}
        variant="transparentNeutral"
      />
    </div>
  );
};
